import React, { useEffect, useRef, useState } from "react"
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const Faq = ({ title, items, image }) => {
  const lineRef = useRef()
  const [itemsOpen, setItemsOpen] = useState([])

  useEffect(() => {
    const sections = document.querySelectorAll('.faq');

    sections.forEach((section) => {
      const liner = section.querySelector('.liner');
      const image = section.querySelector('.faq__image');
      const content = section.querySelector('.faq__content');

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          toggleActions: "play none none none",
        },
      })

      tl.fromTo(liner,
        { height: 0 },
        { height: '100%', duration: 1, ease: "power2.inOut" }
      )
        .fromTo(image,
          { opacity: 0 },
          { opacity: 1, duration: 0.5, ease: "power2.inOut" },
          "-=0.3"
        )
        .fromTo(content,
          { opacity: 0 },
          { opacity: 1, duration: 0.5, ease: "power2.inOut" },
          "-=0.1"
        );
    })
  }, [])

  return (
    <section className={`faq faq__reverse`}>
      <div className="faq__inner">
        {title && <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">{parse(title)}</h2>}

        <div className="liner"></div>
        <div className="faq__wrapper">
          {image &&
            <div className="faq__image">
              <Asset asset={image} />
            </div>
          }
          <div className="faq__content">
            {items && items.map((item, index) => (
              <div className={`faq__item ${itemsOpen[index] ? 'faq__item--open' : ''}`} key={index}>
                <h3 className="faq__question" onClick={() => setItemsOpen((prev) => {
                  const newItemsOpen = [...prev]
                  if (newItemsOpen[index]) {
                    newItemsOpen[index] = false
                  } else {
                    newItemsOpen[index] = true
                  }
                  return newItemsOpen
                }
                )}>
                  <span className='title'>{item.question}</span>
                  <button className="faq__toggle">
                    <span />
                    <span />
                  </button>
                </h3>
                <div className="faq__answer">
                  {item.answer && <StructuredText data={item.answer} />}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Faq

export const query = graphql`
  fragment FaqProps on DatoCmsFaq {
    ... on DatoCmsFaq {
      id
      title
      items {
        question
        answer {
          value
        }
      }
      image {
        ...InternalAssetProps
      }
    }
  }
`
